module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av540-f971a5acf2ff9249110ab3b3ef4bc0e3.jpg";